var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGraphIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 36,
    viewBox: "0 0 37 36",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 1
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.2138 30.0008C22.1133 30.0008 22.0098 29.9963 21.9063 29.9858C20.5863 29.8553 19.5513 28.9238 19.2663 27.6113L15.2418 9.02326L11.0973 18.5963C10.8588 19.1453 10.3173 19.5008 9.72031 19.5008H5.22031C4.39081 19.5008 3.72031 18.8288 3.72031 18.0008C3.72031 17.1713 4.39081 16.5008 5.22031 16.5008H8.73631L12.4953 7.81726C13.0278 6.59326 14.2008 5.88076 15.5343 6.01426C16.8543 6.14476 17.8893 7.07626 18.1743 8.38876L22.1988 26.9768L26.3433 17.4038C26.5818 16.8548 27.1218 16.5008 27.7203 16.5008H32.2203C33.0498 16.5008 33.7203 17.1713 33.7203 18.0008C33.7203 18.8288 33.0498 19.5008 32.2203 19.5008H28.7043L24.9453 28.1828C24.4548 29.3123 23.4033 30.0008 22.2138 30.0008Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraphIcon);
export default __webpack_public_path__ + "static/media/graph-icon.5b6594f4.svg";
export { ForwardRef as ReactComponent };